namespace Matrix.Indexation {
    export interface IndexesRow {
        IndexCode?: string;
        Name?: string;
        LocalCurrencyCode?: string;
        IndexTypeCode?: string;
        PriceSource1?: string;
        PriceSource1Id?: string;
        PriceSource1Type?: string;
        PriceSource2?: string;
        PriceSource2Id?: string;
        PriceSource2Type?: string;
        FxOtherCurrency?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
        LocalCurrencyName?: string;
        LocalCurrencyRowId?: number;
        LocalCurrencyDefaultSortOrder?: number;
        IndexTypeName?: string;
        IndexTypeRowId?: number;
        IndexTypeDefaultSortOrder?: number;
        PriceSource1Name?: string;
        PriceSource1SourceGroup?: string;
        PriceSource1SourceCategory?: string;
        PriceSource1SourceId?: number;
        PriceSource1RowId?: number;
        PriceSource2Name?: string;
        PriceSource2SourceGroup?: string;
        PriceSource2SourceCategory?: string;
        PriceSource2SourceId?: number;
        PriceSource2RowId?: number;
        FxOtherCurrencyName?: string;
        FxOtherCurrencyRowId?: number;
        FxOtherCurrencyDefaultSortOrder?: number;
        BasketConstituents?: BasketConstituentRow[];
    }

    export namespace IndexesRow {
        export const idProperty = 'IndexCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Indexation.Indexes';
        export const lookupKey = 'Indexation.Indexes';

        export function getLookup(): Q.Lookup<IndexesRow> {
            return Q.getLookup<IndexesRow>('Indexation.Indexes');
        }
        export const deletePermission = 'DataAdmin:Indexes';
        export const insertPermission = 'DataAdmin:Indexes';
        export const readPermission = 'Read:Indexes';
        export const updatePermission = 'DataAdmin:Indexes';

        export declare const enum Fields {
            IndexCode = "IndexCode",
            Name = "Name",
            LocalCurrencyCode = "LocalCurrencyCode",
            IndexTypeCode = "IndexTypeCode",
            PriceSource1 = "PriceSource1",
            PriceSource1Id = "PriceSource1Id",
            PriceSource1Type = "PriceSource1Type",
            PriceSource2 = "PriceSource2",
            PriceSource2Id = "PriceSource2Id",
            PriceSource2Type = "PriceSource2Type",
            FxOtherCurrency = "FxOtherCurrency",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder",
            LocalCurrencyName = "LocalCurrencyName",
            LocalCurrencyRowId = "LocalCurrencyRowId",
            LocalCurrencyDefaultSortOrder = "LocalCurrencyDefaultSortOrder",
            IndexTypeName = "IndexTypeName",
            IndexTypeRowId = "IndexTypeRowId",
            IndexTypeDefaultSortOrder = "IndexTypeDefaultSortOrder",
            PriceSource1Name = "PriceSource1Name",
            PriceSource1SourceGroup = "PriceSource1SourceGroup",
            PriceSource1SourceCategory = "PriceSource1SourceCategory",
            PriceSource1SourceId = "PriceSource1SourceId",
            PriceSource1RowId = "PriceSource1RowId",
            PriceSource2Name = "PriceSource2Name",
            PriceSource2SourceGroup = "PriceSource2SourceGroup",
            PriceSource2SourceCategory = "PriceSource2SourceCategory",
            PriceSource2SourceId = "PriceSource2SourceId",
            PriceSource2RowId = "PriceSource2RowId",
            FxOtherCurrencyName = "FxOtherCurrencyName",
            FxOtherCurrencyRowId = "FxOtherCurrencyRowId",
            FxOtherCurrencyDefaultSortOrder = "FxOtherCurrencyDefaultSortOrder",
            BasketConstituents = "BasketConstituents"
        }
    }
}
